import { trpc } from "@/lib/trpc";
import { useCallback, useMemo } from "react";

export function useAuth() {
  const { data: user, isLoading: loading, error: queryError } = trpc.auth.me.useQuery(undefined, {
    retry: false,
    refetchOnWindowFocus: false,
  });

  const logoutMutation = trpc.auth.logout.useMutation();

  const isAuthenticated = useMemo(() => !!user, [user]);

  const error = queryError?.message ?? null;

  const logout = useCallback(async () => {
    try {
      await logoutMutation.mutateAsync();
    } catch {
      // ignore logout errors
    }
    // Force a full page reload to clear all client state
    window.location.href = "/";
  }, [logoutMutation]);

  return {
    user: user ?? null,
    loading,
    error,
    isAuthenticated,
    logout,
  };
}
